import React from 'react'

import { IPartyNumberMap } from '../../models/TypeHelper'
import PollNumberSlider from './PollNumberSlider'
import { PredictionModel } from '../../utils/ReduxStore'

interface IProps {
  annotations?: boolean
  polls: IPartyNumberMap
  handlePollingUpdate: (newPolls: IPartyNumberMap, invalidate: boolean) => void
  predictionModel: PredictionModel
  lastReset: number
}

interface IState {
  polls: IPartyNumberMap
}

export default class NationalPolls extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props)

    this.state = {
      polls: props.polls
    }

    this.handlePollingUpdateFromSlider = this.handlePollingUpdateFromSlider.bind(
      this
    )
  }

  public handlePollingUpdateFromSlider(newPolls: IPartyNumberMap): void {
    this.setState({ polls: newPolls })
    this.props.handlePollingUpdate(newPolls, true)
  }

  public componentDidUpdate(prevProps: IProps): void {
    if (prevProps.lastReset !== this.props.lastReset) {
      this.setState({ polls: this.props.polls })
    }
  }

  public render(): JSX.Element {
    // const isRandomized = this.props.predictionModel === 'randomized'
    const { polls } = this.state

    return (
      <React.Fragment>
        <div>
          <PollNumberSlider
            annotations={this.props.annotations}
            resultsWillRandomize
            handlePollingUpdate={this.handlePollingUpdateFromSlider}
            polls={polls}
          />
        </div>
        {/* {isRandomized && (
          <div className="col-1">
            <button
              className="btn btn-dark"
              onClick={(): void =>
                this.props.handlePollingUpdate(this.state.polls, false)
              }
            >
              <i className="fa fa-refresh mr-2" />
              &nbsp;Generate
            </button>
          </div>
        )} */}

        {/* <button
            className="btn btn-dark btn-lg mt-3 ml-3"
            onClick={(): void => {
              for (let i = 0; i < 100; i++) {
                this.props.handlePollingUpdate(this.state.polls, false)
              }
            }}
          >
            Generate result x 100
          </button> */}
      </React.Fragment>
    )
  }
}
